import React from "react";
import { find, findLast } from "lodash";
import { Trans } from "react-i18next";

const ContactDetails = ({ contact, t, hideAttention}) => {
  const {
    AttentionTo,
    AddressLine1,
    AddressLine2,
    AddressLine3,
    AddressLine4,
    City,
    Region,
    PostalCode,
    Country,
  } = findLast(contact.Addresses, { AddressType: "POBOX" }) || {};
  const { Name, LegalName } = contact;

  return (
    <div className="contact-container">
      <div className="mb-2">
        {Name || LegalName}
      </div>
      {!hideAttention && 
        <div className="attention mb-1">
          {AttentionTo && <span><strong><Trans>Attention</Trans></strong>: {AttentionTo}</span>}
        </div>
      }
      <div className="address d-flex flex-column">
        {AddressLine1 && <div className="address"><span className="mr-1 font-weight-bold"><Trans>Address</Trans>:</span>{AddressLine1} {AddressLine2 && `, ${AddressLine2}`}</div>}
        {AddressLine3 && <div className="address"><span className="mr-1 font-weight-bold"><Trans>Plot Number</Trans>:</span> {AddressLine3}</div>}
        {AddressLine4 && <div className="address"><span className="mr-1 font-weight-bold"><Trans>Building Number</Trans>:</span> {AddressLine4}</div>}
        { City && <div className="address"><span className="mr-1 font-weight-bold"><Trans>City</Trans>:</span> {City}</div>}
        { Region && <div className="address"><span className="mr-1 font-weight-bold"><Trans>Region</Trans>:</span> {Region}</div>}
        { PostalCode && <div className="address"><span className="mr-1 font-weight-bold"><Trans>Postal Code</Trans>:</span> {PostalCode}</div>}
        { Country && <div className="address"><span className="mr-1 font-weight-bold"><Trans>Country</Trans>:</span> {Country}</div>}
      </div>
    </div>
  )

};

export default ContactDetails;
